import React from "react";
import { ArrowRight } from "lucide-react";

const CTA_IMG =
  "https://images.pexels.com/photos/8228578/pexels-photo-8228578.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800";

export const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative bg-black text-white py-24 md:py-32 lg:py-40 overflow-hidden border-t border-zinc-900"
    >
      <div
        className="absolute inset-0 bg-no-repeat bg-cover bg-center grayscale opacity-40"
        style={{ backgroundImage: `url('${CTA_IMG}')` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black/60" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-4xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-zinc-500" />
            <span className="font-mono text-[10px] md:text-xs tracking-[0.4em] uppercase text-zinc-300">
              The Final Word
            </span>
          </div>
          <h2 className="font-display font-light uppercase leading-[0.95] tracking-tight text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
            Ready to<br />
            Operate at a<br />
            Higher Level?
          </h2>
          <p className="mt-10 max-w-2xl font-sans text-base md:text-lg text-zinc-300 leading-relaxed">
            Join CAMO and gain access to a private digital operations network.
          </p>
          <div className="mt-12">
            <a
              href="#membership"
              data-testid="final-cta-button"
              className="group inline-flex items-center justify-between gap-8 bg-white text-black font-mono uppercase text-[11px] tracking-[0.3em] px-10 py-6 hover:bg-zinc-200 transition-colors duration-300"
            >
              <span>Become a Member</span>
              <ArrowRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
